import ct from "class-types.macro";

const baseAlertStyle = ct("rounded", "border-solid", "border", "py-2", "px-4");

export const successAlertStyle = ct(
  "bg-green-50",
  "border-green-100",
  baseAlertStyle,
);

export const errorAlertStyle = ct(
  "bg-red-200",
  "border-red-300",
  baseAlertStyle,
);

export const infoAlertStyle = ct(
  "bg-blue-50",
  "border-blue-500",
  baseAlertStyle,
);
